import axiosInstance from './api'

/**
 * Fetch upcoming sessions for dashboard
 */
export const fetchSessions = async () => {
	try {
		const response = await axiosInstance.get('/counseling/sessions')
		return response.data
	} catch (error) {
		console.error('Error fetching sessions:', error)
		throw error
	}
}

export const mockDashboardSessions = [
	{
		id: 1,
		startsInMin: 9,
		studentName: 'David Lee',
		grade: 12,
		timeLabel: 'Today, 12:00PM',
		avatarUrl: '',
	},
	{
		id: 2,
		startsInMin: 12,
		studentName: 'Sarah Chen',
		grade: 11,
		timeLabel: 'Today, 12:30PM',
		avatarUrl: '',
	},
	{
		id: 3,
		startsInMin: 18,
		studentName: 'Marcus Johnson',
		grade: 12,
		timeLabel: 'Today, 01:00PM',
		avatarUrl: '',
	},
]
